import React from 'react';
import { Mail } from 'react-feather';
import styled from 'styled-components';
import IconContainer from './IconContainer';
const IconContainerExtended = styled(IconContainer) `
    background: #535353;
    svg {
        stroke: #535353;
        stroke-width: 1px;
    }
`;
const IxuMail = (props) => (React.createElement(IconContainerExtended, { ...props },
    React.createElement(Mail, { color: "white" })));
export default IxuMail;
//# sourceMappingURL=IxuMail.js.map